import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import UserIcon from '../../img/icon-user.png'
import { logout } from './Accounts/API'
import { logOut as logOutConnect } from '../actions/account'
import { setDialog as setDialogConnect } from '../actions/navigation'
import { startNewProject as startNewProjectConnect } from '../actions/savedState'

const AccountMenu = ({
    showMenu,
    hideMenu,
    startNewProject,
    account: { name, email, permissions },
    clearUserDetails,
    setDialog
}) => {
    return (
        <menu className={`account-menu ${showMenu ? 'show' : ''}`}>
            <ul>
                <li>
                    <div className="userCard">
                        <div className="userInfo">
                            <div className="name">{name}</div>
                            <div className="email">{email}</div>
                        </div>
                        <img src={UserIcon} aria-hidden="true" alt="" />
                    </div>
                </li>
                <div className="dividingLine" />
                {(permissions.canDownloadFeedback || permissions.canDownloadErrors) && (
                    <li>
                        {/* Using anchor instead of 'react-router-dom.Link' because map has errors when unmounting */}
                        <a href="download-csv/">
                            <button type="button">Download feedback reports</button>
                        </a>
                    </li>
                )}
                <li>
                    <button type="button" onClick={startNewProject}>
                        Start New Project
                    </button>
                </li>
                <li>
                    <button type="button" onClick={() => setDialog('projectLoad')}>
                        Manage Projects
                    </button>
                </li>
                <li>
                    <button
                        type="button"
                        onClick={() => {
                            logout()
                            clearUserDetails()
                            hideMenu()
                        }}
                    >
                        Sign out
                    </button>
                </li>
            </ul>
        </menu>
    )
}

AccountMenu.propTypes = {
    showMenu: PropTypes.bool.isRequired,
    hideMenu: PropTypes.func.isRequired,
    account: PropTypes.shape({
        name: PropTypes.string,
        email: PropTypes.string,
        permissions: PropTypes.shape({
            canDownloadFeedback: PropTypes.bool,
            canDownloadErrors: PropTypes.bool
        })
    }).isRequired,
    clearUserDetails: PropTypes.func.isRequired,
    setDialog: PropTypes.func.isRequired,
    startNewProject: PropTypes.func.isRequired
}

export default connect(
    ({ account: { name, email, permissions } }) => ({ account: { name, email, permissions } }),
    dispatch => ({
        clearUserDetails: () => dispatch(logOutConnect()),
        setDialog: dialogName => dispatch(setDialogConnect(dialogName)),
        startNewProject: () => dispatch(startNewProjectConnect())
    })
)(AccountMenu)
